import {permiteRol} from '../../utils/permisosRol';
import {gestionarEvento} from '../../utils/eventosService';
import EventoWizard from './EventoWizard';
import {rutaArte as rutaArteEvento} from '../../utils/eventoWizard';
import { normalizarEmpresasPermitidas, obtenerEventosAccesibles, obtenerEmpresasDelAlcance } from '../../utils/eventAccess';
// src/pages/eventos/Eventos.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../../firebase/firebaseConfig';
import { useAuth } from '../../context/AuthContext';
import { collection, addDoc, doc, serverTimestamp, updateDoc, query, where, writeBatch } from 'firebase/firestore';
import { getDocs } from '../../utils/firestoreRead';

import { INVITACION_DEFAULT_LAYOUT } from '../shared/InvitacionRender';



function parseLocalDateTime(valor) {
  if (!valor) return null;
  if (valor?.toDate) return valor.toDate();
  const texto = String(valor);
  const fecha = new Date(texto);
  return Number.isNaN(fecha.getTime()) ? null : fecha;
}

function combinarFechaHora(fecha, hora) {
  if (!fecha) return '';
  return `${fecha}T${hora || '00:00'}`;
}

function sumarDiasISO(fechaISO, dias) {
  if (!fechaISO) return '';
  const fecha = new Date(`${fechaISO}T00:00:00`);
  fecha.setDate(fecha.getDate() + dias);
  return fecha.toISOString().slice(0, 10);
}

function compararHoras(horaA, horaB) {
  const [aH = 0, aM = 0] = String(horaA || '00:00').split(':').map(Number);
  const [bH = 0, bM = 0] = String(horaB || '00:00').split(':').map(Number);
  return (aH * 60 + aM) - (bH * 60 + bM);
}

function formatearRangoEvento(inicio, fin) {
  if (!inicio) return 'Sin fecha';
  const opcionesFecha = { day: '2-digit', month: 'short', year: 'numeric' };
  const opcionesHora = { hour: '2-digit', minute: '2-digit' };
  const fechaInicio = inicio.toLocaleDateString('es-BO', opcionesFecha);
  const horaInicio = inicio.toLocaleTimeString('es-BO', opcionesHora);
  if (!fin) return `${fechaInicio} ${horaInicio}`;
  const fechaFin = fin.toLocaleDateString('es-BO', opcionesFecha);
  const horaFin = fin.toLocaleTimeString('es-BO', opcionesHora);
  if (inicio.toDateString() === fin.toDateString()) {
    return `${fechaInicio} · ${horaInicio} - ${horaFin}`;
  }
  return `${fechaInicio} ${horaInicio} → ${fechaFin} ${horaFin}`;
}

function obtenerRangoEvento(evento) {
  const fechaBase = String(evento?.fechaTexto || '').slice(0, 10);
  const inicio = parseLocalDateTime(evento?.fechaInicio || (fechaBase ? `${fechaBase}T21:00` : null));

  let fin = parseLocalDateTime(evento?.fechaFin);
  if (!fin && fechaBase) {
    fin = parseLocalDateTime(`${sumarDiasISO(fechaBase, 1)}T06:00`);
  }

  return { inicio, fin };
}



export default function Eventos() {
  const { user, profile, usuario } = useAuth() || {};
  const rolActual = profile?.rol || usuario?.rol || 'pendiente';
  const empresaUsuarioId = normalizarEmpresasPermitidas(profile || {})[0] || null;
  const empresaUsuarioNombre = profile?.empresaNombre || usuario?.empresaNombre || '';
  const esOwner = permiteRol(profile||usuario,'eventos.gestionar');

  const [nombre, setNombre] = useState('');
  const [fecha, setFecha] = useState('');
  const [horaInicio, setHoraInicio] = useState('22:00');
  const [fechaFin, setFechaFin] = useState('');
  const [horaFin, setHoraFin] = useState('06:00');
  const [empresaId, setEmpresaId] = useState('');
  const [arteInvitacion, setArteInvitacion] = useState('');
  const [arteEntrada, setArteEntradas] = useState('');
  const [empresas, setEmpresas] = useState([]);
  const [eventos, setEventos] = useState([]);
  const [mensaje, setMensaje] = useState('');
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [eventoEditar,setEventoEditar]=useState(null);
  const [vistaEventos, setVistaEventos] = useState('activos');

  const navigate = useNavigate();

  const empresasDisponibles = useMemo(() => {
    const mapa = new Map();
    empresas.forEach((e) => {
      if (e?.id) mapa.set(e.id, { id: e.id, nombre: e.nombre || e.id });
    });
    return Array.from(mapa.values()).sort((a, b) => a.nombre.localeCompare(b.nombre));
  }, [empresas]);

  const cargarEmpresas = async () => {
    try {
      const lista = await obtenerEmpresasDelAlcance();
      setEmpresas(lista);
    } catch (error) {
      console.warn('No se pudieron cargar empresas oficiales:', error);
      setEmpresas([]);
    }
  };

  const obtenerEventos = async () => {
    try {
      const lista = await obtenerEventosAccesibles('eventos');
      setEventos(lista);
    } catch (error) {
      console.error('Error cargando eventos:', error);
      setEventos([]);
      setMensaje(error.message || 'Error al cargar eventos');
    }
  };

  useEffect(() => {
    cargarEmpresas();
    obtenerEventos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [esOwner, empresaUsuarioId, profile]);

  useEffect(() => {
    if (!mostrarFormulario) return;
    if (!esOwner && empresaUsuarioId) {
      setEmpresaId(empresaUsuarioId);
    } else if (!empresaId) {
      setEmpresaId(empresas[0]?.id || '');
    }
  }, [mostrarFormulario, esOwner, empresaUsuarioId, empresaId, empresas]);

  const resolverEmpresaEvento = async () => {
    if (!esOwner) {
      if (!empresaUsuarioId) throw new Error('No tienes una empresa autorizada para crear eventos.');
      const asignada = empresas.find((e) => e.id === empresaUsuarioId);
      if (!asignada) throw new Error('La empresa asignada debe existir en el módulo Empresas.');
      return {
        empresaId: empresaUsuarioId,
        empresaNombre: asignada.nombre,
      };
    }

    const seleccionada = empresasDisponibles.find((e) => e.id === empresaId);
    if (!seleccionada) throw new Error('Selecciona una empresa oficial del módulo Empresas.');
    return { empresaId: seleccionada.id, empresaNombre: seleccionada.nombre };
  };

  const crearEvento = async () => {
    const arteInvTexto = arteInvitacion.trim();
    const arteEntTexto = arteEntrada.trim();

    if (!nombre || !fecha || !horaInicio || !fechaFin || !horaFin || (!arteInvTexto && !arteEntTexto)) {
      setMensaje('Completa nombre, fecha/hora de inicio, fecha/hora de fin y al menos un arte: invitaciones o entradas');
      return;
    }

    const fechaInicioISO = combinarFechaHora(fecha, horaInicio);
    const fechaFinISO = combinarFechaHora(fechaFin, horaFin);
    const inicioEvento = parseLocalDateTime(fechaInicioISO);
    const finEvento = parseLocalDateTime(fechaFinISO);

    if (!inicioEvento || !finEvento || finEvento <= inicioEvento) {
      setMensaje('La fecha/hora de fin debe ser posterior a la fecha/hora de inicio');
      return;
    }

    if (esOwner && !empresaId) {
      setMensaje('Selecciona o escribe la empresa/cliente del evento');
      return;
    }

    try {
      const normalizarRutaArte = (valor) => {
        if (!valor) return null;
        return valor.startsWith('/eventos/') ? valor : `/eventos/${valor}`;
      };

      const arteInv = normalizarRutaArte(arteInvTexto);
      const arteEnt = normalizarRutaArte(arteEntTexto);

      const empresa = await resolverEmpresaEvento();

      const nuevoEvento = {
        nombre,
        fechaInicio: fechaInicioISO,
        fechaFin: fechaFinISO,
        empresaId: empresa.empresaId,
        empresaNombre: empresa.empresaNombre,
        ...(arteInv && { arteInvitacion: arteInv }),
        ...(arteEnt && { arteEntrada: arteEnt }),
        layoutInvitacion: { ...INVITACION_DEFAULT_LAYOUT },
        createdAt: serverTimestamp(),
      };

      await addDoc(collection(db, 'eventos'), nuevoEvento);
      setMensaje('Evento creado');

      setNombre('');
      setFecha('');
      setHoraInicio('22:00');
      setFechaFin('');
      setHoraFin('06:00');
      setEmpresaId(esOwner ? empresas[0]?.id || '' : empresaUsuarioId || '');
      setArteInvitacion('');
      setArteEntradas('');
      setMostrarFormulario(false);

      cargarEmpresas();
      obtenerEventos();
    } catch (e) {
      console.error('Error al crear el evento:', e);
      setMensaje('Error al crear el evento');
    }
  };

  const actualizarDocumentosPorEvento = async (coleccion, campoEvento, eventoId, datosActualizar) => {
    // IMPORTANTE: No usar un while con limit() para actualizar documentos que siguen
    // coincidiendo con el mismo filtro, porque Firestore devolvería los mismos docs
    // una y otra vez. Eso provocaba que "updatedAt" se modificara sin parar.
    const q = query(collection(db, coleccion), where(campoEvento, '==', eventoId));
    const snapshot = await getDocs(q);

    if (snapshot.empty) return 0;

    let batch = writeBatch(db);
    let operaciones = 0;
    let totalActualizados = 0;

    for (const documento of snapshot.docs) {
      batch.update(documento.ref, datosActualizar);
      operaciones += 1;
      totalActualizados += 1;

      if (operaciones >= 450) {
        await batch.commit();
        batch = writeBatch(db);
        operaciones = 0;
      }
    }

    if (operaciones > 0) {
      await batch.commit();
    }

    return totalActualizados;
  };


  const eliminarEvento = async (id) => {
    if(!window.confirm('¿Eliminar este evento y sus invitaciones, entradas y reservas?'))return;
    try{
      setMensaje('Eliminando evento…');
      await gestionarEvento({accion:'eliminar',eventoId:id});
      setEventos(prev=>prev.filter(e=>e.id!==id));
      try{const key='palmarama-evento-borrador-'+(user?.uid||usuario?.uid||profile?.uid);if(localStorage.getItem(key)===id){localStorage.removeItem(key);localStorage.removeItem(key+'-datos');}}catch{}
      setMensaje('Evento eliminado.');
    }catch(e){console.error('Error al eliminar evento:',e);setMensaje(e.message||'No se pudo eliminar el evento.');}
  };

  const normalizarRutaArte = (valor) => {
    const trimmed = String(valor || '').trim();
    if (!trimmed) return '';
    if (trimmed.startsWith('http')) return trimmed;
    return trimmed.startsWith('/eventos/') ? trimmed : `/eventos/${trimmed.replace(/^\//, '')}`;
  };

  const construirActualizacionArtes = ({ evento, nuevoArteInvitacion, nuevoArteEntrada }) => {
    const actualizacion = {
      updatedAt: serverTimestamp(),
    };

    if (nuevoArteInvitacion !== undefined) actualizacion.arteInvitacion = nuevoArteInvitacion;
    if (nuevoArteEntrada !== undefined) actualizacion.arteEntrada = nuevoArteEntrada;

    return actualizacion;
  };

  const manejarEditarArteInvitaciones = async (evento) => {
    const actual = evento.arteInvitacion || '';
    const nuevo = window.prompt('Nombre del archivo del arte para INVITACIONES (solo el nombre o con ruta):', actual);
    if (nuevo === null) return;

    const arteInvPath = normalizarRutaArte(nuevo);
    if (!arteInvPath) return;

    try {
      const datos = construirActualizacionArtes({ evento, nuevoArteInvitacion: arteInvPath });
      await updateDoc(doc(db, 'eventos', evento.id), datos);

      setEventos((prev) => prev.map((ev) => (ev.id === evento.id ? { ...ev, ...datos, updatedAt: new Date() } : ev)));
      setMensaje('Arte de invitaciones actualizado. El evento ya aparecerá en el módulo de invitaciones.');
    } catch (e) {
      console.error('Error actualizando arte de invitaciones', e);
      setMensaje('Error al actualizar el arte de invitaciones');
    }
  };

  const manejarEditarArteEntradas = async (evento) => {
    const actual = evento.arteEntrada || '';
    const nuevo = window.prompt('Nombre del archivo del arte para ENTRADAS (solo el nombre o con ruta):', actual);
    if (nuevo === null) return;

    const arteEntPath = normalizarRutaArte(nuevo);
    if (!arteEntPath) return;

    try {
      const datos = construirActualizacionArtes({ evento, nuevoArteEntrada: arteEntPath });
      await updateDoc(doc(db, 'eventos', evento.id), datos);

      setEventos((prev) => prev.map((ev) => (ev.id === evento.id ? { ...ev, ...datos, updatedAt: new Date() } : ev)));
      setMensaje('Arte de entradas actualizado. El evento ya aparecerá en el módulo de entradas.');
    } catch (e) {
      console.error('Error actualizando arte de entradas', e);
      setMensaje('Error al actualizar el arte de entradas');
    }
  };

  const quitarPermisosDeUsuariosDeOtraEmpresa = async (eventoId, nuevaEmpresaId) => {
    const usuariosSnap = await getDocs(collection(db, 'usuarios'));
    let batch = writeBatch(db);
    let operaciones = 0;
    let usuariosActualizados = 0;

    for (const usuarioDoc of usuariosSnap.docs) {
      const data = usuarioDoc.data();
      const eventosPermitidos = data.eventosPermitidos || {};
      const rolUsuario = data.rol || '';
      const usuarioEmpresaId = data.empresaId || '';

      if (
        rolUsuario !== 'owner' &&
        usuarioEmpresaId !== nuevaEmpresaId &&
        Object.prototype.hasOwnProperty.call(eventosPermitidos, eventoId)
      ) {
        const eventosPermitidosLimpios = { ...eventosPermitidos };
        delete eventosPermitidosLimpios[eventoId];
        batch.update(usuarioDoc.ref, { eventosPermitidos: eventosPermitidosLimpios });
        operaciones += 1;
        usuariosActualizados += 1;

        if (operaciones >= 450) {
          await batch.commit();
          batch = writeBatch(db);
          operaciones = 0;
        }
      }
    }

    if (operaciones > 0) await batch.commit();
    return usuariosActualizados;
  };

  const abrirModalCambiarEmpresa = (evento) => {
    if (!esOwner) return;
    setMenuAbierto(null);
    setModalEmpresaEvento(evento);
    setEmpresaModalId(evento.empresaId || '');
  };

  const cerrarModalCambiarEmpresa = () => {
    if (empresaModalProcesando) return;
    setModalEmpresaEvento(null);
    setEmpresaModalId('');
  };

  const guardarCambioEmpresa = async () => {
    const evento = modalEmpresaEvento;
    if (!evento || !esOwner) return;

    const empresaSeleccionada = empresasDisponibles.find((emp) => emp.id === empresaModalId);
    if (!empresaSeleccionada) { setMensaje('Selecciona una empresa oficial. Las empresas se crean en el módulo Empresas.'); return; }
    const nuevaEmpresaId = empresaSeleccionada.id;
    const nuevaEmpresaNombre = empresaSeleccionada.nombre;

    if ((evento.empresaId || '') === nuevaEmpresaId) {
      setMensaje('El evento ya pertenece a esa empresa');
      cerrarModalCambiarEmpresa();
      return;
    }

    try {
      setEmpresaModalProcesando(true);
      setMensaje('Cambiando empresa del evento y datos relacionados...');

      const datosEmpresa = {
        empresaId: nuevaEmpresaId,
        empresaNombre: nuevaEmpresaNombre,
        updatedAt: serverTimestamp(),
      };

      // Primero actualizamos el documento principal del evento.
      // Así evitamos que invitaciones/entradas queden con empresa nueva
      // pero el evento siga sin empresaId/empresaNombre si alguna operación posterior falla.
      await updateDoc(doc(db, 'eventos', evento.id), datosEmpresa);

      const invitacionesActualizadas = await actualizarDocumentosPorEvento('invitaciones', 'eventoId', evento.id, datosEmpresa);
      const entradasActualizadas = await actualizarDocumentosPorEvento('entradas', 'eventoId', evento.id, datosEmpresa);

      let reservasActualizadas = 0;
      let avisoReservas = '';
      try {
        reservasActualizadas = await actualizarDocumentosPorEvento('reservas', 'eventoId', evento.id, datosEmpresa);
      } catch (errorReservas) {
        console.warn('No se pudieron actualizar reservas relacionadas:', errorReservas);
        avisoReservas = ' Las reservas no se actualizaron por permisos de Firestore.';
      }

      const usuariosActualizados = await quitarPermisosDeUsuariosDeOtraEmpresa(evento.id, nuevaEmpresaId);

      setEventos((prev) =>
        prev.map((ev) => (ev.id === evento.id ? { ...ev, empresaId: nuevaEmpresaId, empresaNombre: nuevaEmpresaNombre } : ev))
      );

      setModalEmpresaEvento(null);
        cargarEmpresas();
      setMensaje(
        `Empresa cambiada. Invitaciones: ${invitacionesActualizadas}, entradas: ${entradasActualizadas}, reservas: ${reservasActualizadas}, permisos limpiados: ${usuariosActualizados}.${avisoReservas}`
      );
    } catch (e) {
      console.error('Error cambiando empresa del evento:', e);
      setMensaje('Error al cambiar la empresa del evento');
    } finally {
      setEmpresaModalProcesando(false);
    }
  };

  const [busqueda, setBusqueda] = useState('');
  const [empresaFiltro, setEmpresaFiltro] = useState('todas');
  const [menuAbierto, setMenuAbierto] = useState(null);
  const [modalEmpresaEvento, setModalEmpresaEvento] = useState(null);

  useEffect(() => {
    if (!menuAbierto) return;

    const cerrarMenuAlHacerClickFuera = (event) => {
      if (event.target.closest('[data-gestion-menu="true"]')) return;
      setMenuAbierto(null);
    };

    document.addEventListener('mousedown', cerrarMenuAlHacerClickFuera);
    return () => document.removeEventListener('mousedown', cerrarMenuAlHacerClickFuera);
  }, [menuAbierto]);
  const [empresaModalId, setEmpresaModalId] = useState('');
  const [empresaModalProcesando, setEmpresaModalProcesando] = useState(false);

  const ahora = new Date();

  const eventosConEstado = useMemo(() => {
    return eventos.map((ev) => {
      const { inicio, fin } = obtenerRangoEvento(ev);
      const enCurso = !!(inicio && fin && inicio <= ahora && fin >= ahora);
      const finalizado = !!(fin && fin < ahora);
      const proximo = !!(inicio && inicio > ahora);
      return { ...ev, _inicioDate: inicio, _finDate: fin, _enCurso: enCurso, _finalizado: finalizado, _proximo: proximo };
    });
  }, [eventos]);

  const eventosFiltrados = useMemo(() => {
    const texto = busqueda.trim().toLowerCase();
    return eventosConEstado
      .filter((ev) => {
        const coincideTexto = !texto ||
          String(ev.nombre || '').toLowerCase().includes(texto) ||
          String(ev.empresaNombre || '').toLowerCase().includes(texto) ||
          String(ev.fechaTexto || '').toLowerCase().includes(texto) ||
          String(ev.fechaInicio || '').toLowerCase().includes(texto) ||
          String(ev.fechaFin || '').toLowerCase().includes(texto);

        const coincideEmpresa = empresaFiltro === 'todas' || (ev.empresaId || '') === empresaFiltro;
        const coincideVista = vistaEventos === 'historial' ? ev._finalizado : !ev._finalizado;
        return coincideTexto && coincideEmpresa && coincideVista;
      })
      .sort((a, b) => {
        if (vistaEventos === 'historial') {
          return (b._inicioDate?.getTime?.() || 0) - (a._inicioDate?.getTime?.() || 0);
        }
        if (a._enCurso !== b._enCurso) return a._enCurso ? -1 : 1;
        return (a._inicioDate?.getTime?.() || 0) - (b._inicioDate?.getTime?.() || 0);
      });
  }, [eventosConEstado, busqueda, empresaFiltro, vistaEventos]);

  const eventosActivos = eventosConEstado.filter((ev) => !ev._finalizado);
  const eventosFinalizados = eventosConEstado.filter((ev) => ev._finalizado);

  const empresasActivas = useMemo(() => {
    return new Set(eventosActivos.map((ev) => ev.empresaId || '')).size;
  }, [eventosActivos]);

  const eventosProximos = eventosConEstado.filter((ev) => ev._proximo).length;
  const eventosHoy = eventosConEstado.filter((ev) => ev._enCurso).length;

  const eventoTieneInvitaciones = (evento) => !!(
    evento?.arteInvitacion ||
    evento?.arteInvitacion
  );

  const eventoTieneEntradas = (evento) => !!(
    evento?.arteEntrada ||
    evento?.arteEntrada
  );

  const rutaArte = (evento) => {
    const arteMostrar = evento.arteInvitacion || evento.arteEntrada || '';
    if (!arteMostrar) return '';
    return rutaArteEvento(arteMostrar);
  };

  const estadoEvento = (evento) => {
    if (evento._enCurso) return { texto: 'En curso', style: badgeHoy };
    if (evento._proximo) return { texto: 'Próximo', style: badgeActivo };
    return { texto: 'Finalizado', style: badgePasado };
  };

  const manejarAccion = (accion, evento) => {
    setMenuAbierto(null);
    if (accion === 'wizard'){setEventoEditar(evento.id);setMostrarFormulario(true);}
    if (accion === 'cambiarEmpresa') abrirModalCambiarEmpresa(evento);
    if (accion === 'combos') navigate(`/admin/eventos/${evento.id}/combos`);
    if (accion === 'paquetes') navigate(`/admin/eventos/${evento.id}/reservas-paquetes`);
    if (accion === 'arteInvitacion') manejarEditarArteInvitaciones(evento);
    if (accion === 'arteEntrada') manejarEditarArteEntradas(evento);
    if (accion === 'calibrarEntrada') navigate(`/admin/eventos/${evento.id}/calibrar-entrada`);
    if (accion === 'calibrarInvitacion') navigate(`/admin/eventos/${evento.id}/calibrar`);
    if (accion === 'eliminar') eliminarEvento(evento.id);
  };

  if(mostrarFormulario&&esOwner)return <EventoWizard key={eventoEditar||'nuevo'} eventoId={eventoEditar} onCerrar={()=>{setMostrarFormulario(false);obtenerEventos();}} onPublicado={()=>{setMostrarFormulario(false);setMensaje('Evento publicado correctamente');obtenerEventos();}}/>;

  return (
    <div className="pm-eventos" style={pageWrap}>
      <div style={headerBox}>
        <div>
          <h2 style={title}>Gestión de Eventos</h2>
          <p style={subtitle}>Administra eventos, empresas, invitaciones, entradas y reservas desde un solo panel.</p>
        </div>
        <button type="button" onClick={() => {setEventoEditar(null);setMostrarFormulario((prev) => !prev);}} style={btnCrearPrincipal}>
          {mostrarFormulario ? 'Cancelar' : '+ Crear evento'}
        </button>
      </div>



      {mostrarFormulario && (
        <div style={formBox}>
          <label style={label}>Nombre del evento</label>
          <input value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Ej: Viernes Urbano" style={input} />

          <div style={dateTimeGrid}>
            <div>
              <label style={label}>Fecha de inicio</label>
              <input
                type="date"
                value={fecha}
                onChange={(e) => {
                  const nuevaFecha = e.target.value;
                  setFecha(nuevaFecha);
                  if (!fechaFin) {
                    setFechaFin(compararHoras(horaFin, horaInicio) <= 0 ? sumarDiasISO(nuevaFecha, 1) : nuevaFecha);
                  }
                }}
                style={input}
              />
            </div>
            <div>
              <label style={label}>Hora de inicio</label>
              <input type="time" value={horaInicio} onChange={(e) => setHoraInicio(e.target.value)} style={input} />
            </div>
            <div>
              <label style={label}>Fecha de fin</label>
              <input type="date" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} style={input} />
            </div>
            <div>
              <label style={label}>Hora de fin</label>
              <input type="time" value={horaFin} onChange={(e) => setHoraFin(e.target.value)} style={input} />
            </div>
          </div>
          <div style={helperText}>Para eventos nocturnos usa fecha de fin del día siguiente, por ejemplo 22:00 → 06:00.</div>

          <label style={label}>Empresa / cliente</label>
          {esOwner ? (
            <>
              <select value={empresaId} onChange={(e) => setEmpresaId(e.target.value)} style={input}>
                {empresasDisponibles.map((emp) => (
                  <option key={emp.id} value={emp.id}>{emp.nombre}</option>
                ))}
              </select>
            </>
          ) : (
            <input value={empresaUsuarioNombre || empresaUsuarioId || 'Sin empresa'} disabled style={{ ...input, background: '#f1f5f9' }} />
          )}

          <label style={label}>Nombre del archivo del arte para invitaciones [OPCIONAL]</label>
          <input value={arteInvitacion} onChange={(e) => setArteInvitacion(e.target.value)} placeholder="Ej: Festival de la cumbia_Invitacion.png" style={input} />

          <label style={label}>Nombre del archivo del arte para entradas [OPCIONAL]</label>
          <div style={{ color: '#64748b', fontSize: 12, marginTop: -6, marginBottom: 8 }}>Puedes llenar solo invitaciones, solo entradas o ambos. El evento solo aparecerá en los módulos que tengan arte configurado.</div>
          <input value={arteEntrada} onChange={(e) => setArteEntradas(e.target.value)} placeholder="Ej: Festival de la cumbia_Entrada.png" style={input} />

          <button onClick={crearEvento} style={{ ...btnCrearPrincipal, width: '100%', borderRadius: 10 }}>Aceptar</button>
        </div>
      )}

      {mensaje && <div style={mensajeStyle(mensaje)}>{mensaje}</div>}

      {modalEmpresaEvento && (
        <div style={modalOverlay} onClick={cerrarModalCambiarEmpresa}>
          <div style={modalCard} onClick={(e) => e.stopPropagation()}>
            <div style={modalHeader}>
              <div>
                <h3 style={modalTitle}>🏢 Cambiar empresa del evento</h3>
                <p style={modalSubtitle}>Actualiza el evento y todos sus datos relacionados.</p>
              </div>
              <button type="button" onClick={cerrarModalCambiarEmpresa} style={modalClose}>×</button>
            </div>

            <div style={modalInfoBox}>
              <span style={modalLabelSmall}>Evento</span>
              <strong>{modalEmpresaEvento.nombre}</strong>
              <span style={modalLabelSmall}>Empresa actual</span>
              <span style={badgeEmpresa}>🏢 {modalEmpresaEvento.empresaNombre || 'Sin empresa'}</span>
            </div>

            <label style={label}>Seleccionar empresa existente</label>
            <select
              value={empresaModalId}
              onChange={(e) => {
                setEmpresaModalId(e.target.value);
                          }}
              style={input}
              disabled={empresaModalProcesando}
            >
              {empresasDisponibles.map((emp) => (
                <option key={emp.id} value={emp.id}>{emp.nombre}</option>
              ))}
            </select>


            <div style={modalWarning}>
              <strong>Importante:</strong> también se actualizarán invitaciones, entradas y reservas de este evento.
              Además se quitará este evento de usuarios que pertenezcan a otra empresa.
            </div>

            <div style={modalActions}>
              <button type="button" onClick={cerrarModalCambiarEmpresa} style={btnModalCancel} disabled={empresaModalProcesando}>Cancelar</button>
              <button type="button" onClick={guardarCambioEmpresa} style={btnModalSave} disabled={empresaModalProcesando}>
                {empresaModalProcesando ? 'Guardando...' : 'Guardar cambios'}
              </button>
            </div>
          </div>
        </div>
      )}

      <div style={kpiGrid}>
        <div style={kpiCard}><span style={kpiLabel}>Total eventos</span><strong style={kpiValue}>{eventos.length}</strong></div>
        <div style={kpiCard}><span style={kpiLabel}>Empresas activas</span><strong style={kpiValue}>{empresasActivas}</strong></div>
        <div style={kpiCard}><span style={kpiLabel}>Próximos</span><strong style={kpiValue}>{eventosProximos}</strong></div>
        <div style={kpiCard}><span style={kpiLabel}>Hoy</span><strong style={kpiValue}>{eventosHoy}</strong></div>
      </div>

      <div style={filtersBox}>
        <input
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          placeholder="Buscar por evento, empresa o fecha..."
          style={searchInput}
        />
        <select value={empresaFiltro} onChange={(e) => setEmpresaFiltro(e.target.value)} style={filterSelect}>
          <option value="todas">Todas las empresas</option>
          {empresasDisponibles.map((emp) => (
            <option key={emp.id} value={emp.id}>{emp.nombre}</option>
          ))}
        </select>
      </div>

      <div style={tabsBox}>
        <button
          type="button"
          onClick={() => setVistaEventos('activos')}
          style={vistaEventos === 'activos' ? tabActivo : tab}
        >
          Activos / próximos ({eventosActivos.length})
        </button>
        <button
          type="button"
          onClick={() => setVistaEventos('historial')}
          style={vistaEventos === 'historial' ? tabActivo : tab}
        >
          Historial ({eventosFinalizados.length})
        </button>
      </div>

      <section style={sectionBox}>
        <div style={sectionHeader}>
          <div>
            <h3 style={sectionTitle}>{vistaEventos === 'historial' ? 'Historial de eventos' : 'Eventos activos y próximos'}</h3>
            <p style={sectionDescription}>{vistaEventos === 'historial' ? 'Eventos que ya terminaron, disponibles para consulta o gestión.' : 'Ordenados desde el evento en curso o más próximo hasta el más distante.'}</p>
          </div>
          <span style={sectionHint}>{eventosFiltrados.length} resultado(s)</span>
        </div>

        <div style={eventCardsGrid}>
          {eventosFiltrados.map((ev) => {
            const arte = rutaArte(ev);
            const estado = estadoEvento(ev);
            const tieneArteEntradas = eventoTieneEntradas(ev);
            const tieneArteInvitaciones = eventoTieneInvitaciones(ev);
            return (
              <article key={ev.id} style={eventCard}>
                <div style={eventThumbBox}>
                  {arte ? (
                    <img src={arte} alt={ev.nombre} style={eventThumb} onError={(e) => (e.target.style.display = 'none')} />
                  ) : (
                    <div style={eventThumbEmpty}>Sin arte</div>
                  )}
                </div>

                <div style={eventInfo}>
                  <div style={eventTopLine}>
                    <span style={badgeEmpresa}>{ev.empresaNombre || 'Sin empresa'}</span>
                    <span style={estado.style}>{estado.texto}</span>
                  </div>

                  <h4 style={eventName}>{ev.nombre}</h4>

                  <div style={eventMetaRow}>
                    <span>🕒 {formatearRangoEvento(ev._inicioDate, ev._finDate)}</span>
                    <span>{tieneArteInvitaciones ? 'Invitación' : ''}{tieneArteInvitaciones && tieneArteEntradas ? ' + ' : ''}{tieneArteEntradas ? 'Entrada' : ''}</span>
                  </div>
                </div>

                <div style={eventActions} data-gestion-menu="true">
                  <button
                    type="button"
                    onClick={() => setMenuAbierto(menuAbierto === ev.id ? null : ev.id)}
                    style={btnGestionar}
                  >
                    Gestionar ⋯
                  </button>

                  {menuAbierto === ev.id && (
                    <div style={menuBox}>
                      {esOwner&&['entradas','reservas'].map(tipo=><button key={tipo} style={menuItem} onClick={async()=>{try{const key=tipo==='entradas'?'entradasBloqueadas':'reservasBloqueadas';await gestionarEvento({accion:'bloquearVentas',eventoId:ev.id,tipo,bloqueado:!ev[key]});setEventos(rows=>rows.map(e=>e.id===ev.id?{...e,[key]:!ev[key]}:e));setMenuAbierto(null);}catch(e){setMensaje(e.message);}}}>{(ev[tipo==='entradas'?'entradasBloqueadas':'reservasBloqueadas']?'Habilitar ':'Bloquear ')+tipo}</button>)}
                      {esOwner && <button style={menuItem} onClick={() => manejarAccion('wizard',ev)}>Configurar</button>}
                      {!ev.ventasDesdeLista&&['owner', 'socio'].includes(rolActual) && <button style={menuItem} onClick={() => manejarAccion('combos', ev)}>🍾 Configurar combos</button>}
                      {esOwner && tieneArteEntradas && <button style={menuItem} onClick={() => manejarAccion('calibrarEntrada', ev)}>📐 Calibrar entrada</button>}
                      {esOwner && tieneArteInvitaciones && <button style={menuItem} onClick={() => manejarAccion('calibrarInvitacion', ev)}>📐 Calibrar invitación</button>}
                      {esOwner&&<button style={menuItemDanger} onClick={() => manejarAccion('eliminar', ev)}>🗑️ Eliminar evento</button>}
                    </div>
                  )}
                </div>
              </article>
            );
          })}

          {eventosFiltrados.length === 0 && (
            <div style={emptyBox}>No se encontraron eventos.</div>
          )}
        </div>
      </section>

    </div>
  );
}


const pageWrap = { padding: 28, maxWidth: 1180, margin: '0 auto', fontFamily: 'var(--pm-font)' };
const headerBox = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, marginBottom: 18 };
const title = { margin: 0, fontSize: 28, fontWeight: 700, color: 'var(--pm-text)' };
const subtitle = { margin: '6px 0 0', color: 'var(--pm-muted)', fontSize: 14 };
const label = { display: 'block', marginBottom: 8, fontWeight: 700, color: 'var(--pm-text)' };
const input = { width: '100%', padding: 11, borderRadius: 10, border: '1px solid var(--pm-border)', marginBottom: 15, boxSizing: 'border-box', outline: 'none' };
const formBox = { background: 'var(--pm-surface)', padding: 20, borderRadius: 18, boxShadow: '0 12px 30px rgba(15,23,42,0.08)', border: '1px solid var(--pm-border)', marginBottom: 22 };
const dateTimeGrid = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12 };
const helperText = { color: 'var(--pm-muted)', fontSize: 12, marginTop: -8, marginBottom: 14 };
const btnCrearPrincipal = { background: 'var(--pm-accent)', color: 'var(--pm-on-accent)', padding: '11px 18px', borderRadius: 12, border: 'none', fontWeight: 700, cursor: 'pointer', boxShadow: '0 8px 18px rgba(0,0,0,0.15)' };
const kpiGrid = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 14, margin: '18px 0' };
const kpiCard = { background: 'var(--pm-surface)', color: 'var(--pm-text)', border: '1px solid var(--pm-border)', borderRadius: 16, padding: 18, boxShadow: 'none' };
const kpiLabel = { display: 'block', color: 'var(--pm-muted)', fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 6 };
const kpiValue = { fontSize: 26, lineHeight: 1 };
const filtersBox = { display: 'grid', gridTemplateColumns: '1fr 240px', gap: 12, marginBottom: 20 };
const searchInput = { padding: 12, borderRadius: 14, border: '1px solid var(--pm-border)', outline: 'none' };
const filterSelect = { padding: 12, borderRadius: 14, border: '1px solid var(--pm-border)', background: 'var(--pm-surface)', outline: 'none' };
const tabsBox = { display: 'flex', flexWrap: 'wrap', gap: 10, margin: '0 0 16px' };
const tab = { border: '1px solid var(--pm-border)', background: 'var(--pm-surface)', color: 'var(--pm-muted)', borderRadius: 12, padding: '10px 14px', fontWeight: 700, cursor: 'pointer' };
const tabActivo = { ...tab, background: 'var(--pm-success-bg)', color: 'var(--pm-success-text)', borderColor: 'var(--pm-accent)', boxShadow: 'none' };
const sectionBox = { background: 'var(--pm-surface)', border: '1px solid var(--pm-border)', borderRadius: 22, padding: 18, marginTop: 18, boxShadow: '0 10px 28px rgba(15,23,42,0.06)', overflow: 'visible' };
const sectionHeader = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, marginBottom: 14 };
const sectionTitle = { margin: 0, fontSize: 20, color: 'var(--pm-text)', fontWeight: 700 };
const sectionHint = { color: 'var(--pm-muted)', fontSize: 13, fontWeight: 700, background: 'var(--pm-input)', border: '1px solid var(--pm-border)', borderRadius: 12, padding: '7px 11px' };
const badgeEmpresa = { display: 'inline-flex', alignItems: 'center', width: 'fit-content', padding: '5px 10px', borderRadius: 12, background: 'var(--pm-success-bg)', color: 'var(--pm-success-text)', fontSize: 12, fontWeight: 700 };
const badgeActivo = { position: 'absolute', top: 10, right: 10, padding: '5px 9px', borderRadius: 12, background: 'var(--pm-success-bg)', color: 'var(--pm-success-text)', fontSize: 12, fontWeight: 700 };
const badgeHoy = { position: 'absolute', top: 10, right: 10, padding: '5px 9px', borderRadius: 12, background: 'var(--pm-warning-bg)', color: 'var(--pm-warning-text)', fontSize: 12, fontWeight: 700 };
const badgePasado = { position: 'absolute', top: 10, right: 10, padding: '5px 9px', borderRadius: 12, background: 'var(--pm-border)', color: 'var(--pm-muted)', fontSize: 12, fontWeight: 700 };
const emptyBox = { gridColumn: '1 / -1', padding: 30, borderRadius: 18, background: 'var(--pm-input)', color: 'var(--pm-muted)', textAlign: 'center', border: '1px dashed #cbd5e1', fontWeight: 700 };
const sectionDescription = { margin: '5px 0 0', color: 'var(--pm-muted)', fontSize: 13 };
const eventCardsGrid = { display: 'grid', gap: 14, overflow: 'visible' };
const eventCard = { display: 'grid', gridTemplateColumns: '118px 1fr auto', alignItems: 'center', gap: 18, padding: 16, border: '1px solid var(--pm-border)', borderRadius: 18, background: 'var(--pm-surface)', boxShadow: '0 8px 22px rgba(15,23,42,0.05)', position: 'relative', overflow: 'visible' };
const eventThumbBox = { width: 118, height: 82, borderRadius: 14, overflow: 'hidden', background: 'var(--pm-border)', border: '1px solid var(--pm-border)', flexShrink: 0 };
const eventThumb = { width: '100%', height: '100%', objectFit: 'cover', display: 'block' };
const eventThumbEmpty = { width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--pm-muted)', fontWeight: 700, fontSize: 12 };
const eventInfo = { minWidth: 0 };
const eventTopLine = { display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginBottom: 8 };
const eventName = { margin: 0, color: 'var(--pm-text)', fontSize: 20, fontWeight: 700, lineHeight: 1.2 };
const eventMetaRow = { display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 14, marginTop: 8, color: 'var(--pm-muted)', fontSize: 13, fontWeight: 700 };
const eventActions = { position: 'relative', justifySelf: 'end', alignSelf: 'center' };
const tableWrap = { overflowX: 'auto' };
const table = { width: '100%', borderCollapse: 'separate', borderSpacing: 0, minWidth: 820 };
const th = { textAlign: 'left', padding: '12px 10px', color: 'var(--pm-muted)', fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.4, borderBottom: '1px solid var(--pm-border)' };
const tr = { background: 'var(--pm-surface)' };
const td = { padding: '12px 10px', borderBottom: '1px solid var(--pm-surface-raised)', verticalAlign: 'middle', color: 'var(--pm-text)' };
const thumb = { width: 74, height: 54, borderRadius: 10, objectFit: 'cover', display: 'block' };
const thumbEmpty = { width: 74, height: 54, borderRadius: 10, background: 'var(--pm-border)', color: 'var(--pm-muted)', fontSize: 11, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700 };
const mutedText = { marginTop: 4, color: 'var(--pm-muted)', fontSize: 12 };
const btnGestionar = { background: 'linear-gradient(135deg, var(--pm-accent), var(--pm-accent))', color: 'var(--pm-on-accent)', padding: '12px 18px', borderRadius: 12, border: 'none', fontWeight: 700, cursor: 'pointer', boxShadow: '0 10px 22px rgba(0,0,0,0.15)', letterSpacing: 0.2, minWidth: 132 };
const menuBox = { position: 'absolute', right: 0, top: 52, width: 270, background: 'var(--pm-surface)', border: '1px solid var(--pm-border)', borderRadius: 16, boxShadow: '0 22px 55px rgba(15,23,42,0.22)', padding: 8, zIndex: 80, textAlign: 'left' };
const menuItem = { width: '100%', background: 'transparent', border: 'none', padding: '10px 12px', textAlign: 'left', borderRadius: 10, cursor: 'pointer', fontWeight: 700, color: 'var(--pm-text)' };
const menuItemDanger = { ...menuItem, color: 'var(--pm-danger-text)' };

const modalOverlay = { position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.58)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 18, zIndex: 1000 };
const modalCard = { width: '100%', maxWidth: 560, background: 'var(--pm-surface)', borderRadius: 22, padding: 22, boxShadow: '0 30px 80px rgba(15,23,42,0.35)', border: '1px solid var(--pm-border)' };
const modalHeader = { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, marginBottom: 16 };
const modalTitle = { margin: 0, color: 'var(--pm-text)', fontSize: 22, fontWeight: 700 };
const modalSubtitle = { margin: '6px 0 0', color: 'var(--pm-muted)', fontSize: 13 };
const modalClose = { border: 'none', background: 'var(--pm-surface-raised)', color: 'var(--pm-text)', width: 34, height: 34, borderRadius: 12, cursor: 'pointer', fontSize: 22, lineHeight: '30px', fontWeight: 700 };
const modalInfoBox = { background: 'var(--pm-input)', border: '1px solid var(--pm-border)', borderRadius: 16, padding: 14, display: 'grid', gap: 7, marginBottom: 16 };
const modalLabelSmall = { color: 'var(--pm-muted)', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.4 };
const modalWarning = { background: 'var(--pm-warning-bg)', border: '1px solid var(--pm-warning-text)', color: 'var(--pm-warning-text)', borderRadius: 14, padding: 12, fontSize: 13, lineHeight: 1.45, marginTop: 4 };
const modalActions = { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 18 };
const btnModalCancel = { padding: '11px 16px', borderRadius: 12, border: '1px solid var(--pm-border)', background: 'var(--pm-surface)', color: 'var(--pm-text)', fontWeight: 700, cursor: 'pointer' };
const btnModalSave = { padding: '11px 16px', borderRadius: 12, border: 'none', background: 'var(--pm-accent)', color: 'var(--pm-on-accent)', fontWeight: 700, cursor: 'pointer', boxShadow: '0 10px 20px rgba(0,0,0,0.15)' };

const mensajeStyle = (mensaje) => ({ margin: '15px 0', background: mensaje.includes('Error') ? 'var(--pm-danger-bg)' : 'var(--pm-success-bg)', padding: 12, borderRadius: 12, color: mensaje.includes('Error') ? 'var(--pm-danger-text)' : 'var(--pm-success-text)', textAlign: 'center', fontWeight: 700 });
